<div
  class="flex pr-medium-b chips-container"
  [ngClass]="{
    'ms-xlarge-b': !hasTitle() && hasBorder(),
    'border-bottom': hasBorder(),
  }"
>
  <div class="flex flex--wrap mr-clear chips">
    @for (chip of chips(); track $index) {
      <fcom-chip
        [attr.data-testid]="'tag-' + chip.label"
        [text]="chip.text"
        [title]="chip.text"
        [iconName]="filter() === chip.label ? SvgLibraryIcon.CLOSE_DELETE : null"
        [theme]="filter() === chip.label ? ChipTheme.ACTIVE : ChipTheme.DEFAULT"
        (tagClicked)="toggleContent(chip.label)"
      />
    }
  </div>
</div>
